import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import { gridNumberComparator } from "../hooks/features/sorting/gridSortingUtils.es.js";
import { isNumber } from "../utils/utils.es.js";
import { getGridNumericOperators, getGridNumericQuickFilterFn } from "./gridNumericOperators.es.js";
import { GRID_STRING_COL_DEF } from "./gridStringColDef.es.js";
import { convertQuickFilterV7ToLegacy } from "./utils.es.js";
const GRID_NUMERIC_COL_DEF = _extends({}, GRID_STRING_COL_DEF, {
  type: "number",
  align: "right",
  headerAlign: "right",
  sortComparator: gridNumberComparator,
  valueParser: (value) => value === "" ? null : Number(value),
  valueFormatter: ({
    value
  }) => isNumber(value) ? value.toLocaleString() : value || "",
  filterOperators: getGridNumericOperators(),
  getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridNumericQuickFilterFn),
  getApplyQuickFilterFnV7: getGridNumericQuickFilterFn
});
export {
  GRID_NUMERIC_COL_DEF
};
//# sourceMappingURL=gridNumericColDef.es.js.map
